import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreatores } from 'state';

export const useActions = () => {
  const dispatch = useDispatch();

  return bindActionCreators(actionCreatores, dispatch);
};
